<template>
  <chip :payload="setPayload" />
</template>

<script>
import Chip from '@/app/arch/components/global-components/Chip.vue';
import PrepareChipMixin from '@/app/arch/mixins/PrepareChipMixin';
import ConciliationStatus from 'Modules/contacard/conciliations/transfer/conciliation/components/ConciliationStatus';

export default {
  name: 'ConciliationStatusColumn',
  components: { Chip },
  mixins: [PrepareChipMixin],
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data: (vm) => ({
    status: vm.formatContent(ConciliationStatus),
  }),
  computed: {
    getStatus() {
      return this.status.find(
        (status) => this.isEqual(
          this.toLower(
            status.value,
          ),
          this.toLower(
            this.value,
          ),
        ),
      );
    },
    setPayload() {
      return this.prepare(
        this.getStatus,
      );
    },
  },
  methods: {
    toLower(item = '') {
      return item ? String(item).toLowerCase() : item;
    },
    isEqual(value, value2) {
      return value === value2;
    },
  },
};
</script>
